<template>
  <div class="blue-footer">
    <div class="container">
      <div class="social-sec d-none">
        <ul>
          <li><a href="https://www.facebook.com/b1g1giving" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
          <li><a href="https://www.twitter.com/B1G1" target="_blank"><i class="fab fa-x-twitter"></i></a></li>
          <li><a href="https://www.linkedin.com/company/buy1give1/" target="_blank"><i class="fab fa-linkedin-in"></i></a>
          </li>
          <li><a href="https://www.instagram.com/buy1give1/" target="_blank"><i class="fab fa-instagram"></i></a></li>
        </ul>
      </div>
      <div class="fo-menu-sec">
        <ul>
          <li><a href="https://b1g1.com/" target="_blank">B1G1 Home</a></li>
          <li><a href="https://b1g1.com/about-us" target="_blank">About</a></li>
          <li><a href="https://b1g1.helpscoutdocs.com/" target="_blank">Help Center</a></li>
          <li><a href="https://b1g1.com/terms-and-conditions" target="_blank">Terms</a></li>
        </ul>
      </div>
      <div class="fo-copy-sec d-none">Copyright © 2007 - {{ new Date().getFullYear() }} BUY1GIVE1 PTE LTD / B1G1 Giving, Inc.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      notShowFooterRouteNames: ['payment-redirect']
    }
  }
}
</script>
<style scoped>
.blue-footer {
  background: #171732;
  position: sticky;
  top: 100vh;
}

.blue-footer {
  text-align: center;
  margin-top: 40px;
}

.social-sec a {
  background: #fff;
  width: 31px;
  height: 31px;
  display: inline-block;
  line-height: 31px;
  border-radius: 50px;
  font-size: 18px;
}

.social-sec a:hover {
  box-shadow: 0px 2px 8px rgb(0 0 0 / 30%);
}

.social-sec ul {
  display: flex;
  justify-content: center;
  column-gap: 6px;
}

.fo-copy-sec {
  font-size: 12px;
  color: #fff;
  font-weight: 400;
}

.fo-menu-sec a {
  color: #fff;
  font-size: 16px;
  position: relative;
}

.fo-menu-sec a:hover {
  color: #FF1254;
}

.fo-menu-sec {
  padding: 10px 0px;
}

.fo-menu-sec ul {
  display: flex;
  justify-content: center;
  column-gap: 30px;
}

.fo-menu-sec a:after {
  content: "";
  background: #fff;
  width: 1px;
  height: 14px;
  display: inline-block;
  position: absolute;
  top: 5px;
  right: -16px;
}

.fo-menu-sec li:last-child a:after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/business/Footer.vue